export function visibleRole(role) {
  return role.level === "user";
}
